import { Review } from 'services/api-service'
import trackingService from '../services/tracking-service'
import { turnToConfig } from 'init/config'

function localeToLang(locale: string) {
  return locale ? locale.split('_')[0] : locale
}

function translateReview(
  review: Review,
  originalReviews: Map<number, Review>,
  reviews: Review[],
  showOriginal: boolean
): void {
  const activeIndex = reviews.findIndex(opt => opt.id === review.id)
  const origReview = showOriginal ? originalReviews.get(review.id) :
    reviews[activeIndex]
  reviews[activeIndex] = showOriginal ? origReview : review
  originalReviews.set(review.id, showOriginal ? null : origReview)
  if (!showOriginal) {
    const eventProperties = {
      sl: localeToLang(origReview.locale),
      tl: localeToLang(turnToConfig.locale),
      rid: review.id
    }
    trackingService.queueEvent('reviews-list', 'trans', review.catItem.sku, eventProperties)
  }
}

export default { translateReview }
